// --------------------------------------
// SELECT ELEMENTS FROM THE PAGE
// --------------------------------------
const toggle = document.querySelector('.nav-toggle'); // the hamburger button
const menu = document.querySelector('#nav-menu');     // the nav menu container
const focusableSelectors = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';
const MOBILE_BREAKPOINT = 768; // breakpoint in pixels for mobile vs desktop


// --------------------------------------
// OPEN MOBILE MENU FUNCTION
// --------------------------------------
function openMenu() {
  menu.classList.add('open');               // add "open" class to trigger CSS transitions
  toggle.setAttribute('aria-expanded', 'true'); // mark menu as expanded for accessibility
  document.body.style.overflow = 'hidden';  // prevent background scroll

  // Force the browser to calculate layout before animating children
  menu.offsetHeight; 

  // Animate each menu item with fade/slide
  menu.querySelectorAll('li').forEach((li) => {
    li.style.opacity = '1';
    li.style.transform = 'translateY(0)';
  });

  // Focus the first link for keyboard users
  menu.querySelector('a')?.focus();
}


// --------------------------------------
// CLOSE MOBILE MENU FUNCTION
// --------------------------------------
function closeMenu() {
  // Reset all <li> items to hidden before closing menu
  menu.querySelectorAll('li').forEach((li) => {
    li.style.opacity = '0';
    li.style.transform = 'translateY(-15px)';
  });

  menu.classList.remove('open');               // remove "open" class
  toggle.setAttribute('aria-expanded', 'false'); // mark menu as closed
  document.body.style.overflow = '';           // allow scrolling
  toggle.focus();                              // return focus to toggle button
}


// --------------------------------------
// TOGGLE MENU ON HAMBURGER CLICK
// --------------------------------------
toggle.addEventListener('click', () => {
  const isOpen = toggle.getAttribute('aria-expanded') === 'true';
  isOpen ? closeMenu() : openMenu();
});


// --------------------------------------
// KEYBOARD ACCESSIBILITY
// --------------------------------------
document.addEventListener('keydown', (e) => {
  const expanded = toggle.getAttribute('aria-expanded') === 'true';

  // ESC closes the menu
  if (e.key === 'Escape' && expanded) closeMenu();

  // Trap TAB focus inside menu when open
  if (expanded && e.key === 'Tab') {
    const focusable = menu.querySelectorAll(focusableSelectors);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    // Shift + Tab on first element -> move focus to last
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } 
    // Tab on last element -> move focus to first
    else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
});


// --------------------------------------
// HANDLE WINDOW RESIZE (MOBILE <-> DESKTOP)
// --------------------------------------
function handleResize() {
  if (window.innerWidth > MOBILE_BREAKPOINT) {
    // Desktop: menu should be fully visible
    menu.classList.remove('open');          // remove mobile "open" state
    menu.querySelectorAll('li').forEach((li) => {
      li.style.opacity = '1';
      li.style.transform = 'translateY(0)';
    });
    toggle.setAttribute('aria-expanded', 'false'); // reset toggle
    document.body.style.overflow = '';            // allow scrolling
  } else {
    // Mobile: hide menu items initially
    menu.querySelectorAll('li').forEach((li) => {
      li.style.opacity = '0';
      li.style.transform = 'translateY(-15px)';
    });
  }
}

// Run on page load to set correct state
handleResize();

// Update menu if user resizes window
window.addEventListener('resize', handleResize);
